import Index from '@tunnel-components/@sharded/inhibitions/created/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/inhibitions/created/index.ts